import { render, staticRenderFns } from "./InputPermission.vue?vue&type=template&id=29ab5e53&scoped=true"
import script from "./InputPermission.vue?vue&type=script&lang=js"
export * from "./InputPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ab5e53",
  null
  
)

export default component.exports